// extracted by mini-css-extract-plugin
export default {"accordion":"KbLAU3","accordion-panel":"dUMLKU"};